export const FEATURE_FLAGS = {
  mealTracking: false,
};
